import { type KeyboardEvent, useCallback, useState } from 'react';

import { Button } from 'components/DesignSystem/Button';
import { TextInput } from 'components/DesignSystem/TextInput';
import textInputStyles from 'components/DesignSystem/TextInput/TextInput.module.scss';
import classes from 'components/widgets/ImageUploader/component/ImageFromUrl/ImageFromUrl.module.scss';

const INPUT_ID = 'image-uploader-url-input';
const HELPER_ID = 'image-uploader-url-helper';

const HELPER_TEXT = 'Paste a direct link to an image file (PNG, JPG, SVG, WEBP).';

export type ImageFromUrlProps = {
    onLoadUrl?: (url: string) => void;
};

export const ImageFromUrl = ({ onLoadUrl }: ImageFromUrlProps) => {
    const [url, setUrl] = useState('');

    const load = useCallback(() => {
        const trimmed = url.trim();
        if (!trimmed) {
            return;
        }
        onLoadUrl?.(trimmed);
    }, [onLoadUrl, url]);

    const onKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            load();
        }
    };

    return (
        <div className={classes.root}>
            <div className={classes.fieldGroup}>
                <label htmlFor={INPUT_ID} className={`${textInputStyles.label} ${classes.label}`}>
                    Image URL
                </label>
                <div className={classes.inputRow}>
                    <TextInput
                        id={INPUT_ID}
                        className={classes.textInput}
                        value={url}
                        onChange={(e) => setUrl(e.target.value)}
                        onKeyDown={onKeyDown}
                        placeholder={'https://'}
                        type={'text'}
                        clearable
                        inputMode={'url'}
                        autoComplete={'off'}
                        aria-describedby={HELPER_ID}
                    />
                    <Button type={'button'} variant={'secondary'} className={classes.loadButton} onClick={load}>
                        Load
                    </Button>
                </div>
                <div id={HELPER_ID} className={textInputStyles.helperText}>
                    {HELPER_TEXT}
                </div>
            </div>
        </div>
    );
};

export default ImageFromUrl;
